package com.parmartechnologies.core.feature.employee.model

import com.parmartechnologies.core.extension.BaseDataClass
import kotlinx.serialization.SerialName
import kotlin.time.ExperimentalTime

data class EmployeeAttendance @OptIn(ExperimentalTime::class) constructor(
    @SerialName("user_id") var UserID: String = "",
    @SerialName("employee_id") var EmployeeID: String = "",
    @SerialName("employee_user_id") var EmployeeUserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("is_approved") var IsApproved: Int = 0,
    @SerialName("is_present") var IsPresent: Int = 0,
    @SerialName("hours") var Hours: Int = 0,
    @SerialName("comment") var Comment: String = "",
    @SerialName("attendance_date") var AttendanceDate: String = "",
): BaseDataClass()
